import React from 'react'
import { IconProps } from './icons.models'

export const WatchIcon: React.FC<IconProps> = ({
    width = 11,
    height = 11,
    fillColor = '#898989',
}) => {
    return (
        <svg width={width} height={height} viewBox="0 0 11 11" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M5.2251 10.1016C7.91749 10.1016 10.1001 7.91895 10.1001 5.22656C10.1001 2.53417 7.91749 0.351562 5.2251 0.351562C2.53271 0.351562 0.350098 2.53417 0.350098 5.22656C0.350098 7.91895 2.53271 10.1016 5.2251 10.1016Z" stroke={fillColor} strokeWidth="0.7" strokeLinecap="round" strokeLinejoin="round" />
            <path d="M4.68359 3.05859V5.76693H7.39193" stroke={fillColor} strokeWidth="0.7" strokeLinecap="round" strokeLinejoin="round" />
        </svg>
    )
}
